var _style, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgMrvLogoIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Layer_1",
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  x: "0px",
  y: "0px",
  viewBox: "0 0 45.8 44",
  style: {
    enableBackground: "new 0 0 45.8 44"
  },
  xmlSpace: "preserve",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{fill:url(#SVGID_2_);}\n\t.st2{fill:url(#SVGID_3_);}\n")), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_1_",
  gradientUnits: "userSpaceOnUse",
  x1: 28.5649,
  y1: 45.648,
  x2: 28.5649,
  y2: 2.132,
  gradientTransform: "matrix(1 0 0 -1 0 46)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#FFB81A"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#FF8B22"
  }
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  className: "st0",
  d: "M41.2,0.8L19.9,21.9l8.2,8.1c0.1,0.1,0.2,0.2,0.2,0.3c0,0.1,0.1,0.2,0.1,0.4v5.7c0,0.3-0.1,0.7-0.4,0.9 c-0.2,0.2-0.6,0.4-0.9,0.4H11.3l0,3.6c0,0.3,0.1,0.7,0.2,1c0.1,0.3,0.3,0.6,0.6,0.9c0.2,0.2,0.5,0.4,0.9,0.6c0.3,0.1,0.7,0.2,1,0.2 h29.1c0.3,0,0.7-0.1,1-0.2c0.3-0.1,0.6-0.3,0.9-0.6c0.2-0.2,0.4-0.5,0.6-0.9c0.1-0.3,0.2-0.7,0.2-1V2.6c0-0.5-0.2-1-0.5-1.5 c-0.3-0.4-0.7-0.8-1.2-1c-0.5-0.2-1-0.3-1.5-0.1C42.1,0.2,41.6,0.4,41.2,0.8z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_2_",
  gradientUnits: "userSpaceOnUse",
  x1: 9.9286,
  y1: 39.4958,
  x2: 9.9286,
  y2: 8.5304,
  gradientTransform: "matrix(1 0 0 -1 0 46)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0,
  style: {
    stopColor: "#82EB5C"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#00D38D"
  }
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  className: "st1",
  d: "M11.6,30l8.2-8.1L4.9,7.1C4.5,6.7,4,6.4,3.4,6.3C2.9,6.2,2.3,6.3,1.8,6.5c-0.5,0.2-1,0.6-1.3,1 C0.2,8,0,8.6,0,9.1v25.8c0,0.8,0.3,1.5,0.8,2c0.5,0.5,1.3,0.8,2,0.8h8.5l0-7C11.4,30.4,11.5,30.2,11.6,30L11.6,30z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "SVGID_3_",
  gradientUnits: "userSpaceOnUse",
  x1: 19.8504,
  y1: 9.0548,
  x2: 19.8504,
  y2: 24.0451,
  gradientTransform: "matrix(1 0 0 -1 0 46)"
}, /*#__PURE__*/React.createElement("stop", {
  offset: 0.002,
  style: {
    stopColor: "#079D56"
  }
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  style: {
    stopColor: "#006B3F"
  }
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  className: "st2",
  d: "M28.4,36.4v-5.7c0-0.1,0-0.2-0.1-0.4c0-0.1-0.1-0.2-0.2-0.3l-8.2-8.1L11.6,30c-0.2,0.2-0.3,0.4-0.3,0.6l0,7H27 c0.4,0,0.7-0.1,0.9-0.4C28.2,37.1,28.4,36.8,28.4,36.4L28.4,36.4z"
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgMrvLogoIcon);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/mrvLogo-icon.f82482fff2fd110ceeea9de153eb7575.svg";